import api from "../services/api";

// Role
export const addRole = (data) => {
    return api.post('admin/privilegeRoles/add_role', data);
}

export const updateRole = (data) => {
    return api.put('admin/privilegeRoles/update_role', data);
}

export const updateRoleStatus = (data) => {
    return api.put('admin/privilegeRoles/update_role_status', data);
}

export const deleteRole = (id) => {
    return api.delete('admin/privilegeRoles/delete_role', {
        data: { _id: id }
    });
}

export const getRoleList = (queryParams = "") => {
    return api.get(`/admin/privilegeRoles/role_list${queryParams}`);
};

export const getSpinnerRoleList = (queryParams = "") => {
    return api.get(`/admin/privilegeRoles/spinner_role_list${queryParams}`);
};